import * as React from 'react';
import { Component } from 'react';

interface ICaptchaStoreProps {
  sitekey: string | null;
  handleCaptchaTokenChange(value: string | null): void;
}

const CAPTCHA_SCRIPT_URL = 'https://www.google.com/recaptcha/api.js';
const TIMEOUT_CAPTCHA_SCRIPT_RUN = 150;

/**
 * Проверяем есть ли уже скрипт капчи на странице
 * и добавляем его, если его нет.
 */
function getCaptchaScript(): HTMLScriptElement | null {
  const allScriptsOnPage = Array.prototype.slice.call(document.querySelectorAll('script'));
  const isPageContainCaptchaUrl = allScriptsOnPage.find((script: HTMLScriptElement) => {
    return script.src === CAPTCHA_SCRIPT_URL;
  });

  if (isPageContainCaptchaUrl) {
    return null;
  }

  const captchaScript = document.createElement('script');
  captchaScript.src = CAPTCHA_SCRIPT_URL;

  document.body.appendChild(captchaScript);

  return captchaScript;
}

export class Captcha extends Component<ICaptchaStoreProps, {}> {
  private captchaContainer: HTMLDivElement | null = null;

  public componentDidMount() {
    const captchaScript = getCaptchaScript();

    /**
     * Если скрипта капчи не было, то после его загрузки показываем капчу,
     * если он был сразу показываем капчу
     */
    if (captchaScript) {
      captchaScript.onload = () => setTimeout(() => this.showCaptcha(), TIMEOUT_CAPTCHA_SCRIPT_RUN);
    } else {
      this.showCaptcha();
    }
  }

  public render() {
    return <div ref={captchaContainer => (this.captchaContainer = captchaContainer)} />;
  }

  private showCaptcha = () => {
    const { handleCaptchaTokenChange, sitekey } = this.props;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((window as any).grecaptcha && sitekey) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).grecaptcha.ready(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any).grecaptcha.render(this.captchaContainer, {
          callback: handleCaptchaTokenChange,
          'expired-callback': () => {
            handleCaptchaTokenChange(null);
          },
          sitekey,
        });
      });
    }
  };
}
